import {
    FETCH_CATEGORY_SUCCESS_ACTION,
    FETCH_CATEGORY_BYID_SUCCESS_ACTION
} from './action'

const initialState = {
    processing: false,
    error: false,
}

export default function (state: any = initialState, action: Function) {

    switch (action.type) {
        case FETCH_CATEGORY_SUCCESS_ACTION:

            return {
                ...state,
                CategorysList: action.payload.rows
            }

        default:
            return {
                ...state
            }
    }

}